import React from 'react';
import PropTypes from 'prop-types';

function GlobalTeamRenderer(props) {
  const {
    data, value,
  } = props;
  if (data && data._id) {

    const displayComp = value ? (<span className="label label-warning">Global</span>) : (<span className="label label-default">Private</span>);
    return (
      <div className="text-center">
        {displayComp}
      </div>
    );
  }
  return null;
}
GlobalTeamRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }),
  value: PropTypes.bool,
};
GlobalTeamRenderer.defaultProps = {
  data: null,
  value: false,
};
export default GlobalTeamRenderer;
